import React from 'react';
import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';
import Scanner from './components/Scanner';
import TwitterFeed from './components/TwitterFeed';
import Donate from './components/Donate';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: linear-gradient(135deg, #1a0000 0%, #660000 100%);
    min-height: 100vh;
    color: #fff;
  }

  #root {
    min-height: 100vh;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const Header = styled.header`
  width: 100%;
  max-width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Logo = styled.h1`
  color: #ff4d00;
  font-size: 2rem;
  margin: 0;
  text-shadow: 0 0 10px rgba(255, 77, 0, 0.5);
`;

const MainContent = styled.main`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LinksSection = styled.div`
  width: 100%;
  max-width: 400px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
`;

const LinkGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
`;

const LinkButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a1a1a;
  border: 2px solid #ff4d00;
  color: #ff4d00;
  padding: 12px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;

  &:hover {
    background: #ff4d00;
    color: #1a1a1a;
    transform: translateY(-2px);
  }
`;

const ContractAddress = styled.div`
  width: 100%;
  max-width: 400px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
  text-align: center;

  h2 {
    color: #ff4d00;
    margin-bottom: 15px;
  }

  p {
    color: #fff;
    word-break: break-all;
    font-family: 'Courier New', monospace;
    background: #1a1a1a;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #333;
  }
`;

const App = () => {
  return (
    <>
      <GlobalStyle />
      <AppContainer>
        <Header>
          <Logo>FIREAI</Logo>
        </Header>
        <MainContent>
          <Scanner />
          <LinksSection>
            <h2 style={{ color: '#ff4d00', marginBottom: '15px', textAlign: 'center' }}>Links</h2>
            <div style={{ color: '#ff4d00', marginBottom: '15px', textAlign: 'center', fontWeight: 'bold' }}>
              LIVE UPDATES FROM THE LOS ANGELES FIRES, EXPANDING TO NATION WIDE COVERAGE NEXT!
            </div>
            <LinkGrid>
              <LinkButton href="https://pump.fun/coin/DddZc3zazszdu2h9eNceXu9nAqko3GDCfAiQU5Bipump" target="_blank" rel="noopener noreferrer">
                DexScreener
              </LinkButton>
            </LinkGrid>
          </LinksSection>
          <ContractAddress>
            <h2>Contract Address</h2>
            <p>DddZc3zazszdu2h9eNceXu9nAqko3GDCfAiQU5Bipump </p>
          </ContractAddress>
          <Donate />
          <TwitterFeed />
        </MainContent>
      </AppContainer>
    </>
  );
};

export default App;
